const config = {

    mapLayers: [
        {
            "id": "county",
            "name": "TX:County",
            "label": "County",
            "minZoom": 6,
            "maxZoom": 20
        },
        // {
        //     "id": "parcel",
        //     "name": "DMP_LICENSE/Parcels",
        //     "label": "Parcel",
        //     "minZoom": 14,
        //     "maxZoom": 22
        // },
        {
            "id": "postalcode",
            "name": "TX:ZIP_Boundaries",
            "label": "Postal Codes",
            "minZoom": 6,
            "maxZoom": 20
        },
        {
            "id": "neighborhood",
            "name": "USA:Neighborhoods",
            "label": "Neighborhoods",
            "minZoom": 6,
            "maxZoom": 20
        },
        {
            "id": "district",
            "name": "USA:SchoolDistrict",
            "label": "School Districts",
            "minZoom": 6,
            "maxZoom": 20
        },
        {
            "id": "schoolattzone",
            "name": "USA:SchoolAttendanceZone",
            "label": "School Attendance Zone",
            "minZoom": 6,
            "maxZoom": 20,
        },
        {
            "id": "flood",
            "name": "TX:Flood",
            "label": "Flood Plain",
            "minZoom": 6,
            "maxZoom": 20
        }
    ]

}
export default config;